module.exports = __webpack_public_path__ + "static/media/banndark.3060c677.png";